import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import {
	StyledInputWithLabel,
} from 'lib/styles';

import {
	Container,
	ItemsContainer,
	Wrapper,
	Item,
	InputContainer,
} from './styles';

class ListSelectableItems extends React.Component {
	state = {
	  filter: '',
	}

	render() {
	  const { t, items } = this.props;
	  const showFilter = this.props.showFilter !== false;

	  return (
	    <React.Fragment>
	      <Container>
	        {
	          showFilter &&
						<InputContainer>
						  <StyledInputWithLabel
						    type="text"
						    value={this.state.filter}
						    label={t('building/images/filter')}
						    onChange={e => this.setState({ filter: e.target.value })}
						  />
						</InputContainer>
	        }
	        <ItemsContainer>
	          {
	            items
	              .filter(item => {
	                if (this.state.filter === '') {
	                  return true;
	                }

	                return item.filter.toLowerCase().indexOf(this.state.filter.toLowerCase()) > -1;
	              })
	              .map(item => (
	                <Wrapper key={item.id} onClick={() => this.props.selectItemHandler(item.id)}>
	                  <Item selected={item.selected}>
	                    {item.element}
	                  </Item>
	                </Wrapper>
	              ))
	          }
	        </ItemsContainer>
	      </Container>
	    </React.Fragment>
	  )
	}
}

ListSelectableItems.propTypes = {
	t: PropTypes.func,
	showFilter: PropTypes.bool,
	items: PropTypes.array,
	selectItemHandler: PropTypes.func,
}

export default translate('translations')(ListSelectableItems)
